import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { BriefingStepItem } from '@/shared/briefing'
import type { LvdBriefingStep } from '../../utils/lvdLegislationBriefing'
import { LVD_BRIEFING_ID_PREFIX } from './constants'
import { toV2LvdBriefingStep } from './toV2LvdBriefingStep'

export function V2LvdLegislationBriefingStepShell({
  step,
  index,
  actions,
  children,
}: {
  step: LvdBriefingStep
  index: number
  actions?: ReactNode
  children?: ReactNode
}) {
  const { t } = useTranslation('common')

  return (
    <BriefingStepItem
      idPrefix={LVD_BRIEFING_ID_PREFIX}
      index={index}
      step={toV2LvdBriefingStep(step, t)}
      actions={actions}
    >
      {children}
    </BriefingStepItem>
  )
}
